export default __webpack_public_path__ + "static/media/delete.b56da92e.svg";